export const TournamentRoutes = {
  getTournamentLocations: () => `game-engine/tournaments/location`,
  getTournaments: (locationId?: string) =>
    `game-engine/tournaments${locationId ? `?locationId=${locationId}` : ''}`,
  getTournamentLeaderboard: (tournamentId: string) =>
    `game-engine/tournaments/${tournamentId}/leaderboard`,
};
